import React, { ReactNode } from "react"
import { AndroidSocketProvider, useAndroidSocket } from "./SocketContext.android"
import { ElectronSocketProvider, useElectronSocket } from "./SocketContext.electron"
import type { SocketState } from "./SocketContext.types"

const usePlatformSocket = __IS_CAPACITOR__ ? useAndroidSocket : useElectronSocket

export const SocketProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  if (__IS_CAPACITOR__) {
    return <AndroidSocketProvider>{children}</AndroidSocketProvider>
  }

  return <ElectronSocketProvider>{children}</ElectronSocketProvider>
}

export const useSocket = (): SocketState => usePlatformSocket()
